import type { SanityPageBuilderHeadlineSection, SanityPageBuilderSection } from "@ouster/shared";
import { HeadlineBlockView } from "~/features/blocks/inventory/headline";
import { toCraftLinkArray } from "~/features/sanity/link";
import { SanityRichText } from "~/features/sanity/rich-text";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderHeadlineSection;
  };
};
export function SanityHeadlineSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const text = sectionContent.text?.length ? <SanityRichText value={sectionContent.text} /> : undefined;
  return <HeadlineBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} eyebrow={sectionContent.eyebrow} hasSolidBackground={sectionContent.hasSolidBackground} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} highlight={sectionContent.highlight} isHighlighted={sectionContent.isHighlighted} link={toCraftLinkArray(sectionContent.link)} linkVariant={sectionContent.linkVariant} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} text={text} theme={sectionSettings?.theme || "white"} />;
}